:host {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.top-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.step {
  font-size: $size-text-small;
}

.step-bold {
  @include font(bold);
}

.bar {
  position: relative;
  flex-grow: 1;
  height: 8px;
  background-color: $color-black-5;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
}

.fill {
  height: 100%;
  border-radius: 4px;
  background-color: $color-green-100;
  transition: width 0.3s ease-in-out;

  @container style(--trumpf-ux-animations: disabled) {
    transition-duration: 0s;
  }
}